import { Component, Input } from '@angular/core';

@Component({
    selector: 'kh-inline-notification',
    templateUrl: './inline-notification.component.html',
    styleUrls: ['./inline-notification.component.scss']
})
export class InlineNotificationComponent {
    @Input() iconName = "";
}
